const CREDS_KEY = "icmaa.admin.creds";
const BASE =
  import.meta.env.VITE_API_BASE_URL ?? ""; // same-origin by default

export interface Creds {
  user: string;
  pass: string;
}

export function getCreds(): Creds | null {
  const raw = sessionStorage.getItem(CREDS_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Creds;
  } catch {
    return null;
  }
}

export function setCreds(creds: Creds | null): void {
  if (creds) sessionStorage.setItem(CREDS_KEY, JSON.stringify(creds));
  else sessionStorage.removeItem(CREDS_KEY);
}

export async function apiFetch(
  path: string,
  init: RequestInit = {},
): Promise<Response> {
  const creds = getCreds();
  const headers = new Headers(init.headers);
  if (creds) {
    headers.set("authorization", `Basic ${btoa(`${creds.user}:${creds.pass}`)}`);
  }
  if (init.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  return fetch(`${BASE}${path}`, { ...init, headers });
}

export async function apiJson<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const res = await apiFetch(path, init);
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg =
      typeof body === "object" && body && "error" in body
        ? String((body as { error: unknown }).error)
        : `${res.status} ${res.statusText}`;
    throw new Error(msg);
  }
  return body as T;
}

export interface Tenant {
  id: number;
  code: string;
  short_domain: string;
  base_redirect_url: string;
  default_language: string;
  url_rewrite_from: string | null;
  url_rewrite_enabled: number;
}

export interface ShortUrl {
  id: number;
  tenant_id: number;
  keyword: string;
  country: string;
  target_url: string;
  expires_at: number | null;
}

export interface Analytics {
  tenant: string;
  from: number;
  to: number;
  totals: { total: number; matched: number };
  by_country: Array<{ country: string; clicks: number }>;
  by_keyword: Array<{
    keyword: string;
    clicks: number;
    matched_clicks: number;
  }>;
}
